import React, { useEffect, useState } from "react";
import SshTunnel from "./Ssh/SshTunnel";
import V2ray from "./V2ray/V2ray";
import { levelTypes } from "./SelectDownloadConfig";

export default function DownloadButtonSelectConfig({ setLevel }) {
  const [configBtnsStatus, setConfigBtnsStatus] = useState({
    v2ray: false,
    ssh: false,
  });

  useEffect(() => {
    if (Object.values(configBtnsStatus).every((status) => !status)) {
      setLevel(levelTypes.configSelect);
    }
  }, [configBtnsStatus]);

  return (
    <div class="row mt-3">
      <SshTunnel
        setLevel={setLevel}
        setConfigBtnsStatus={setConfigBtnsStatus}
      />
      <V2ray
        setLevel={setLevel}
        setConfigBtnsStatus={setConfigBtnsStatus}
      />
    </div>
  );
}
